export default function DynamicPreviousDate() {
	const getEnMonthName = (monthNumber) => {
		const monthNames = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December'
		];
		return monthNames[monthNumber];
	};

	const getDynoPrevDate = () => {
		try {
			const todaysDate = new Date();
			const monthsToSubtract = 1;

			todaysDate.setDate(1);
			todaysDate.setMonth(todaysDate.getMonth() - monthsToSubtract);

			const result = getEnMonthName(todaysDate.getMonth()) + ' ' + todaysDate.getFullYear();
			
			// Additional validation to make sure we got a valid result
			if (!result || result.includes('undefined') || result.includes('NaN')) {
				throw new Error('Invalid date calculation result');
			}

			return result;
		} catch (error) {
			// Fallback date in case of any errors
			return 'May 2025';
		}
	};

	return getDynoPrevDate();
};
